import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import { Swiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export const ControlledSwiper = memo(function ControlledSwiper(props) {
    const { children, disabled_drag, ...rest } = props;
    const [controlledSwiper, setControlledSwiper] = useState(null);
    useEffect(() => {
        if (controlledSwiper) {
            if (disabled_drag) {
                controlledSwiper.disable();
            }
            else {
                controlledSwiper.enable();
            }
        }
    }, [disabled_drag]);
    return (_jsx(Swiper, { modules: [...(rest?.modules ?? [])], onSwiper: setControlledSwiper, passiveListeners: false, ...rest, children: children }));
});
